module.exports = __webpack_public_path__ + "img/info.8ff97e85.svg";